import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class IdeasTableCellDeadlineComponent extends Component {
  datePickerInstance = null;

  get idea() {
    return this.args.idea;
  }

  @action
  onDatePickerReady(instance) {
    this.datePickerInstance = instance;
  }

  @action
  openDatePicker() {
    this.datePickerInstance?.open();
  }

  @action
  handleDateChange(idea, date) {
    idea.deadline = date;
    idea.save();
  }

  willDestroy() {
    this.datePickerInstance?.destroy();
    this.datePickerInstance = null;
    super.willDestroy(...arguments);
  }
}
